export default [
    {
        path: '/404',
        meta: { public: true, },
        name: 'NotFound',
        component: () => import('@/views/NotFound.vue')
    },
    {
        path: '/403',
        meta: { public: true, },
        name: 'NotFound',
        component: () => import('@/views/Deny.vue')
    },
    {
        path: '/500',
        meta: { public: true, },
        name: 'NotFound',
        component: () => import('@/views/Error.vue')
    },
    {
        path: '/',
        name: 'home',
        meta: { public: true, title: 'Trang chủ',},
        component: () => import('@/views/Home.vue')
    },
    {
        path: '/dat-hang-thanh-cong/:Pid',
        name: 'completed',
        meta: { public: true, title: 'Đặt hàng thành công',},
        component: () => import('@/views/Completed.vue')
    },
    {
        path: '/chi-tiet-san-pham/:Pid',
        name: 'chi-tiet-san-pham',
        meta: { public: true, title: 'Chi tiết sản phẩm',},
        component: () => import('@/views/ProductDetail.vue')
    },
    {
        path: '/gioi-thieu',
        name: 'gioi-thieu',
        meta: { public: true, title: 'Giới thiệu',},
        component: () => import('@/views/About.vue')
    },
    {
        path: '/chinh-sach-ctv',
        name: 'chinh-sach-ctv',
        meta: { public: true, title: 'Chính sách CTV',},
        component: () => import('@/views/Policy.vue')
    },
    // {
    //     path: '/lien-he',
    //     name: 'lien-he',
    //     meta: { public: true, title: 'Liên hệ',},
    //     component: () => import('@/views/Contact.vue')
    // },
    {
        path: '/san-pham',
        name: 'san-pham',
        meta: { public: true, title: 'Sản phẩm',},
        component: () => import('@/views/Shop.vue')
    },
    {
        path: '/tai-khoan',
        name: 'tai-khoan',
        meta: { title: 'Tài khoản', requiresAuth: true, roleId: 1},
        component: () => import('@/views/Account.vue')
    },
    {
        path: '/dang-nhap',
        name: 'dang-nhap',
        meta: { title: 'Đăng nhập', public: true, },
        component: () => import('@/views/Login.vue')
    }
]